'use client';

import { GetWrapupType, WrapupModuleKillsData } from "@/src/server/models/seasonal/wrapup/modules/getwrapup";
import IWrapupModule from "./imodule";
import WrapupModuleKillsComponent from "./killscomponent";

export default class WrapupModuleKills implements IWrapupModule {
    constructor() { }

    get id(): string { return 'kills'; }
    get name(): string { return 'Kills'; }

    canRender(wrapupData: GetWrapupType): boolean {
        const killsData = wrapupData?.data?.kills as WrapupModuleKillsData;
        return killsData?.killedUserIds?.length > 0;
    }

    getComponentClass() {
        return WrapupModuleKillsComponent;
    }
}
